var arrow_next = '<div class="slick-arrow-container slick-arrow-container-next"><button type="button" class="slick-next">Next</button></div>';
var arrow_prev = '<div class="slick-arrow-container slick-arrow-container-prev"><button type="button" class="slick-prev">Previous</button></div>';

// Logos

jQuery('.m-logos__slides').slick({
	focusOnSelect: true,
	nextArrow: arrow_next,
	prevArrow: arrow_prev,
	slidesToShow: 5,
	responsive: [
		{
			breakpoint: 768,
			settings: {
				focusOnSelect: true,
				slidesToShow: 3
			}
		},
		{
			breakpoint: 480,
			settings: {
				focusOnSelect: true,
				slidesToShow: 2
			}
		}
	]
});

// Product flexible content

jQuery('.m-product__flexible-slides').slick({
	arrows: false,
	dots: true,
	focusOnSelect: true,
	nextArrow: arrow_next,
	prevArrow: arrow_prev,
	slidesToShow: 2,
	responsive: [
		{
			breakpoint: 720,
			settings: {
				focusOnSelect: true,
				slidesToShow: 1
			}
		}
	]
});

// Product gallery

jQuery('.m-product__gallery-medium-slides').slick({
	adaptiveHeight: true,
	arrows: false,
	fade: true,
	slidesToShow: 1,
});

jQuery('.m-product__gallery-thumb-slides').slick({
	arrows: false,
	asNavFor: '.m-product__gallery-medium-slides',
	dots: true,
	focusOnSelect: true,
	nextArrow: arrow_next,
	prevArrow: arrow_prev,
	slidesToShow: 4,
	responsive: [
		{
			breakpoint: 640,
			settings: {
				focusOnSelect: true,
				slidesToShow: 3
			}
		}
	]
});

// Themes

jQuery('.m-home__themes-slides').slick({
	focusOnSelect: true,
	nextArrow: arrow_next,
	prevArrow: arrow_prev,
	slidesToShow: 3,
	responsive: [
		{
			breakpoint: 1280,
			settings: {
				arrows: false,
				dots: true,
				focusOnSelect: true,
				slidesToShow: 3
			}
		},
		{
			breakpoint: 768,
			settings: {
				arrows: false,
				dots: true,
				focusOnSelect: true,
				slidesToShow: 2
			}
		},
		{
			breakpoint: 480,
			settings: {
				arrows: false,
				dots: true,
				focusOnSelect: true,
				slidesToShow: 1
			}
		}
	]
});

// Testimonials

jQuery('.m-home__testimonials-slides').slick({
	arrows: false,
	autoplay: true,
	autoplaySpeed: 6000,
	dots: true,
	fade: true,
	pauseOnHover: false,
	speed: 750
});

// Tweets

jQuery('.m-twitter__tweets').slick({
	arrows: false,
	autoplay: true,
	autoplaySpeed: 6000,
	dots: false,
	fade: true,
	mobileFirst: true,
	slidesToScroll: 1,
	slidesToShow: 1,
	responsive: [
		{
			breakpoint: 768,
			settings: "unslick"
		}
	]
});

// Related Products
jQuery('.m-product__related-slides').slick({
	arrows: true,
	dots: false,
	focusOnSelect: true,
	nextArrow: arrow_next,
	prevArrow: arrow_prev,
	slidesToScroll: 3,
	slidesToShow: 3,
	responsive: [
		{
			breakpoint: 720,
			settings: {
				focusOnSelect: true,
        slidesToScroll: 1,
				slidesToShow: 1
			}
		}
	]
});